/**
 * @flow
 * @relayHash 03f190fce477e335f3578997aab94179
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SsmsAggregations_relayQueryResponse = {|
  +ssmsAggregationsViewer: ?{|
    +explore: ?{|
      +ssms: ?{|
        +aggregations: ?{|
          +consequence__transcript__gene__gene_id: ?{|
            +buckets: ?$ReadOnlyArray<?{|
              +key: ?string;
              +doc_count: ?number;
            |}>;
          |};
        |};
      |};
    |};
  |};
|};
*/


/*
query SsmsAggregations_relayQuery(
  $ssmCountsfilters: FiltersArgument
) {
  ssmsAggregationsViewer: viewer {
    explore {
      ssms {
        aggregations(filters: $ssmCountsfilters, aggregations_filter_themselves: true) {
          consequence__transcript__gene__gene_id {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "ssmCountsfilters",
        "type": "FiltersArgument",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SsmsAggregations_relayQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "ssmsAggregationsViewer",
        "args": null,
        "concreteType": "Root",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Explore",
            "name": "explore",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Ssms",
                "name": "ssms",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "aggregations_filter_themselves",
                        "value": true,
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "filters",
                        "variableName": "ssmCountsfilters",
                        "type": "FiltersArgument"
                      }
                    ],
                    "concreteType": "SsmAggregations",
                    "name": "aggregations",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Aggregations",
                        "name": "consequence__transcript__gene__gene_id",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Bucket",
                            "name": "buckets",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "doc_count",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SsmsAggregations_relayQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "ssmCountsfilters",
        "type": "FiltersArgument",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SsmsAggregations_relayQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "ssmsAggregationsViewer",
        "args": null,
        "concreteType": "Root",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Explore",
            "name": "explore",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Ssms",
                "name": "ssms",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "aggregations_filter_themselves",
                        "value": true,
                        "type": "Boolean"
                      },
                      {
                        "kind": "Variable",
                        "name": "filters",
                        "variableName": "ssmCountsfilters",
                        "type": "FiltersArgument"
                      }
                    ],
                    "concreteType": "SsmAggregations",
                    "name": "aggregations",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Aggregations",
                        "name": "consequence__transcript__gene__gene_id",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Bucket",
                            "name": "buckets",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "doc_count",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query SsmsAggregations_relayQuery(\n  $ssmCountsfilters: FiltersArgument\n) {\n  ssmsAggregationsViewer: viewer {\n    explore {\n      ssms {\n        aggregations(filters: $ssmCountsfilters, aggregations_filter_themselves: true) {\n          consequence__transcript__gene__gene_id {\n            buckets {\n              key\n              doc_count\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/GenesTable/__generated__/SsmsAggregations_relayQuery.graphql.js